"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class ResetToken extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'resetToken';
        this._emailAddress = initParams.email_address;
        this._status = initParams.status;
        this._token = initParams.token;
        this._password = initParams.password;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    setEmailAddress(value) {
        return this.dataService.updateResetToken(this.id, { email_address: value }, this);
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    setStatus(value) {
        return this.dataService.updateResetToken(this.id, { status: value }, this);
    }
    get status() {
        return this._status;
    }
    set token(value) {
        console.error('Do not set objects this way');
    }
    setToken(value) {
        return this.dataService.updateResetToken(this.id, { token: value }, this);
    }
    get token() {
        return this._token;
    }
    set password(value) {
        console.error('Do not set objects this way');
    }
    setPassword(value) {
        return this.dataService.updateResetToken(this.id, { password: value }, this);
    }
    get password() {
        return this._password;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateResetToken(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = ResetToken;
//# sourceMappingURL=resetToken.js.map